const searchList = {
  background: 'white',
  borderRadius: '16px',
  maxHeight: '186px',
  marginTop: '4px',
  height: 'auto',
  overflowY: 'auto',
  minHeight: 0,
  boxShadow: '-40px 40px 80px -8px #919EAB3D',
};

const searchListItemIcon = {
  minWidth: '40px',
};

const mapSearchBox = {
  position: 'relative',
  zIndex: 2,
  margin: '16px 16px 0 16px',
  '@media (min-width:600px)': {
    margin: '28px 40px 0 40px',
  },
};

const mapSearchHeaderBox = {
  zIndex: 2,
  width: '100%',
};

const mapSearchWrapper = {
  position: 'absolute',
  width: '100%',
};

// Header variant: keep the search field in normal flow so it stretches to fill
// the header, instead of floating like the map overlay wrapper.
const mapSearchHeaderWrapper = {
  width: '100%',
};

// Header variant: float the results dropdown below the input (anchored to the
// relatively-positioned list box) so focusing the field doesn't grow the header
// and shift the input.
const mapSearchHeaderList = {
  position: 'absolute',
  top: '100%',
  left: 0,
  width: '100%',
  zIndex: 3,
};

const mapSearchBarListBox = {
  position: 'relative',
  zIndex: 2,
};

const emptyListText = {
  padding: '0 16px',
  opacity: 0.5,
};

const searchListItemIconDisabled = {
  minWidth: '26px',
  marginLeft: '12px',
  marginRight: '4px',
};

const listItem = {
  flex: 'initial',
  '& span': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
};

const filterNotificationBox = {
  position: 'absolute',
  top: '60px',
  width: '100%',
  '@media (min-width:600px)': {
    top: '76px',
  },
};

const mapSearchTextfield = {
  '@media (max-width:600px)': {
    '& fieldset': {
      border: 0,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused': {
        boxShadow: 'none',
      },
    },
  },
};

const mapSearchTextfieldBox = {
  display: 'flex',
  alignItems: 'center',
  padding: '0 8px',
};

export {
  searchList,
  searchListItemIcon,
  mapSearchBox,
  mapSearchHeaderBox,
  mapSearchHeaderWrapper,
  mapSearchHeaderList,
  mapSearchWrapper,
  mapSearchBarListBox,
  emptyListText,
  searchListItemIconDisabled,
  listItem,
  filterNotificationBox,
  mapSearchTextfield,
  mapSearchTextfieldBox,
};
